import React, { createContext, useContext, useMemo, useState } from "react";

interface BasketUIContextValue {
  open: boolean;
  openBasket: () => void;
  closeBasket: () => void;
  toggleBasket: () => void;
}

const BasketUIContext = createContext<BasketUIContextValue | undefined>(
  undefined
);

export const BasketUIProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [open, setOpen] = useState(false);

  const openBasket = () => setOpen(true);
  const closeBasket = () => setOpen(false);
  const toggleBasket = () => setOpen((v) => !v);

  const value = useMemo(
    () => ({ open, openBasket, closeBasket, toggleBasket }),
    [open]
  );

  return (
    <BasketUIContext.Provider value={value}>
      {children}
    </BasketUIContext.Provider>
  );
};

export const useBasketUI = () => {
  const ctx = useContext(BasketUIContext);
  if (!ctx) throw new Error("useBasketUI must be used within BasketUIProvider");
  return ctx;
};
